import React from 'react';
import { formatDate, formatDateTime } from './tenantClock';
import { formatMoney } from './numberFormat';

// What a Receipt shows the same way wherever it's listed: the Payments card
// on a Quote or Sales Order, and Receivables › Receipts (issue #442).

const QBO_TAGS = {
  copied: { label: 'In QuickBooks', color: '#1a7f4b' },
  marked: { label: 'Already in QuickBooks', color: '#5a6b85' },
  failed: { label: 'Not in QuickBooks', color: '#b91c1c' },
};

// In QuickBooks / Void in QuickBooks / Already in QuickBooks / Not in
// QuickBooks, from the Receipt's `quickbooks` state (issue #342). Nothing
// for a Receipt that's never copied.
export function ReceiptQuickbooksTag({ receipt, style }) {
  const qbo = receipt.quickbooks;
  if (!qbo) return null;
  const title = qbo.state === 'marked'
    ? [`Marked ${formatDateTime(receipt.qbo_marked_at)}`, receipt.qbo_marked_by_name ? `by ${receipt.qbo_marked_by_name}` : null].filter(Boolean).join(' ')
    : undefined;
  return (
    <div title={title} style={{ fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap', color: QBO_TAGS[qbo.state].color, ...style }}>
      {qbo.state === 'copied' && qbo.voided ? 'Void in QuickBooks' : QBO_TAGS[qbo.state].label}
    </div>
  );
}

export function receiptVoidedLabel(receipt) {
  return [`Voided ${formatDateTime(receipt.voided_at)}`, receipt.voided_by_name ? `by ${receipt.voided_by_name}` : null].filter(Boolean).join(' ');
}

export function voidReceiptQuestion(receipt) {
  return `Void Receipt ${receipt.display_number}, ${formatMoney(receipt.amount)} (Ref ${receipt.reference}) paid ${formatDate(receipt.payment_date)}? It stays listed as Void and no longer counts towards what's been paid. This cannot be undone.`;
}

export function markInQuickbooksQuestion(receipt) {
  return `Mark Receipt ${receipt.display_number} as already in QuickBooks? It's then never copied there. Only do this when the payment was keyed into QuickBooks by hand.`;
}
